import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Box, IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const CostoNomina = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getPayrollCost, dataReady } = useData();

  // Get data from Excel (3 years: 2023, 2024, 2025)
  const excelData = dataReady ? getPayrollCost() : { labels: [], data2023: [], data2024: [], data2025: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Sector salud/ Farmacéuticas', 'Construcción', 'Automotriz', 'Manufactura', 'Servicios logísticos', 'Alimentos', 'Retail'];

  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [4, 25, 45, 1, 27, 11, 15];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [11, 30, 11, 9, 31, 18, 10];
  const allData2025 = (excelData.data2025 && excelData.data2025.length > 0) ? excelData.data2025 : [14, 11, 11, 9, 20, 10, 12];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#A2AEBB',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#476A8E',
        borderColor: '#fff',
        borderWidth: 1,
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2025),
        backgroundColor: '#1F3D58',
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,
        bottom: 40,
        left: 20,
        right: 40,
      },
    },
    plugins: {
      legend: { position: 'top' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#1F3D58',
        anchor: 'end',
        align: 'right',
        offset: 6,
        clip: false,
        formatter: (value) => `${value}%`,
        font: {
          weight: 'bold',
          size: 11,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Porcentaje %',
        },
        min: 0,
        max: 50,
      },
      y: {
        title: {
          display: true,
          text: 'Industria',
        },
      },
    },
  };

  const infoContent = {
    formula: 'Costo de Nómina Logística (%) = (Costo de Nómina Logística / Venta bruta) x 100',
    description: 'Refleja qué proporción de las ventas se utiliza para cubrir los costos de personal asociados a la operación logística.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CostoNomina;
